<template>
	<div class="row">
		<div class="col-12 mb-4">
			<div class="card shadow-sm border-1">
				<div class="card-body d-flex justify-content-between">
					<div class="d-flex align-items-center border-right pr-5">
						<div class="mr-3">
							<span class="text-warning "
								><i class="fa fa-calendar-day fa-2x"></i
							></span>
						</div>
						<div>
							<span class="text-muted">Contas a pagar Hoje</span>
							<h5 class="font-weight-bold">
								{{ getsumOverDueToday() | decimal }}
							</h5>
						</div>
					</div>

					<div class="d-flex align-items-center border-right pr-5">
						<div class="mr-3">
							<span class="text-danger  ml-2"
								><i class="fa fa-calendar-day fa-2x"></i
							></span>
						</div>
						<div>
							<span class="text-muted">Contas Vencidas</span>
							<h5 class="font-weight-bold">
								{{ getsumOverDueBillPayable() | decimal }}
							</h5>
						</div>
					</div>

					<div class="d-flex align-items-center border-right pr-5">
						<div class="mr-3">
							<span class="text-primary  ml-2"
								><i class="fa fa-calendar-day fa-2x"></i
							></span>
						</div>
						<div>
							<span class="text-muted">Contas a pagar este mês</span>
							<h5 class="font-weight-bold">
								{{ getSumBillsPayableOverDueMonth() | decimal }}
							</h5>
						</div>
					</div>
					<div class="d-flex align-items-center border-right  pr-5">
						<div class="mr-3">
							<span class="text-success  ml-2"
								><i class="fa fa-calendar-day fa-2x"></i
							></span>
						</div>
						<div>
							<span class="text-muted">Contas pagas este mês</span>
							<h5 class="font-weight-bold">
								{{ getsumBillsPayedMonth() | decimal }}
							</h5>
						</div>
					</div>

					<div class="d-flex align-items-center pr-5">
						<div class="mr-3">
							<span class="text-danger ml-2"
								><i class="fa fa-ban fa-2x"></i
							></span>
						</div>
						<div>
							<span class="text-muted">Canceladas</span>
							<h5 class="font-weight-bold">
								{{ getsumCanceled() | decimal }}
							</h5>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			getSumBillsPayableOverDueMonth() {
				return this.$store.getters["billpayable/getSumBillsPayableOverDueMonth"];
			},

			getsumBillsPayedMonth() {
				return this.$store.getters["billpayable/getsumBillsPayedMonth"];
			},

			getsumOverDueBillPayable() {
				return this.$store.getters["billpayable/getsumOverDueBillPayable"];
			},

			getsumOverDueToday() {
				return this.$store.getters["billpayable/getsumOverDueToday"];
			},

			getsumCanceled() {
				return this.$store.getters["billpayable/getsumCanceled"];
			}
		}
	};
</script>

<style lang="scss">
.callout {
  border: 0px solid #eee;
  border-right-width: 1px;
  border-radius: 0px;
  margin-right: 8px;
  margin-left: 8px;
  h5 {
    margin-top: 0;
    margin-bottom: 8px;
    margin-right: 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  code {
    border-radius: 3px;
  }
  & + .bs-callout {
    margin-top: -5px;
  }
}
@each $name, $color in (default, rgba(155, 153, 153, 0.267)), (primary, #428bca),
  (success, #5cb85c), (danger, #d9534f), (primary, #f0ad4e), (info, #5bc0de),
  (bdc, #29527a)
{
  .callout-#{$name} {
    border-right-color: $color;
    h5 {
      color: $color;
    }
  }
}
</style>